import React,{useEffect,useRef,useState} from 'react'
import WebTemplate from '../Components/WebTemplate'
import { useGetAllSchoolsQuery} from '../Services/modules/school';
import { Link,useSearchParams  } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useGetAllCentersQuery, useGetResultMutation } from '../Services/modules/result';
import Spinner from 'react-bootstrap/Spinner';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PersonelResult from '../Components/PersonelResult';
import qrcode from "../assets/img/qrcode.jpeg";
import ShatabdiCenterwiseMeritList from '../Components/ShatabdiCenterwiseMeritList';
import ShatabdiGeneralMeritList from '../Components/ShatabdiGeneralMeritList';
import tse8vi from "../assets/mahitipatrak/TSE8vi.pdf";
import TSE_mahitipatrak from "../assets/mahitipatrak/TSE_mahitipatrak.pdf";
import SSP from "../assets/mahitipatrak/SSP.pdf";

function ShatabdiResult() {
 
    const ShatabdiResultScreen=()=>{  
    
        return(
            <>
             <ToastContainer />
           <section class="heroschoolsResult">
  <div class="heroschoolsResult-content">
    {/* <h2 className="text-overlay" style={{color:'#ffffff'}}>शताब्दि शिष्यवृत्ती परीक्षा 2024-25 अंतिम निकाल (४थी व ७वी)</h2> */}
    <h2 className="text-overlay" style={{color:'#ffffff'}}>शताब्दि शिष्यवृत्ती परीक्षा 2025-26 अंतिम निकाल (४थी व ७वी)</h2>

   
  </div> 
</section>


              <main id="main">
              <section id="clients" class="clients section-bg">
      <div class="container">
 {/* <div class="alert alert-danger text-center" role="alert" style={{fontWeight:'bold'}}>
  पुढील शैक्षणिक वर्षांपासून इयत्ता ५वी व ८वी साठी गुणवत्ता शोध परीक्षा घेतली जाणार असून त्याचा तपशील अंतिम निकालदिवशी प्रसिद्ध केला जाईल.
</div> */}
 <div class="alert alert-danger text-center" role="alert" style={{fontWeight:'bold'}}>
  पुढील शैक्षणिक वर्षांपासून इयत्ता ५वी व ८वी साठी गुणवत्ता शोध परीक्षा घेतली जाणार आहे.
</div>
<div className="row" >
  {/* <div className='col-md-6'>
 <div class="alert alert-danger text-center" role="alert" style={{fontWeight:'bold'}}>
   <a
        href={TSE_mahitipatrak}
        target="_blank"
     //   download="Sainikshala.pdf"
        className="btn btn-success mt-3"
      >
  गुणवत्ता शोध परीक्षा १ली, २री, ३री, ५वी, ६वी माहितीपत्रक बघण्यासाठी येथे क्लिक करा
  </a>
 
</div>
</div>
 <div className='col-md-6'>
 <div class="alert alert-danger text-center" role="alert" style={{fontWeight:'bold'}}>
  <a
        href={tse8vi}
        target="_blank"
     //   download="Sainikshala.pdf"
        className="btn btn-success mt-3"
      >
  गुणवत्ता शोध परीक्षा ८वी माहितीपत्रक बघण्यासाठी येथे क्लिक करा
  </a>
</div>
</div> */}

<div className='col-md-4'>
 <div class="alert alert-danger text-center" role="alert" style={{fontWeight:'bold'}}>
  {/* <a
        href={SSP}
        target="_blank"
     //   download="Sainikshala.pdf"
        className="btn btn-success mt-3"
      >
  शताब्दि शिष्यवृत्ती परीक्षा माहितीपत्रक बघण्यासाठी येथे क्लिक करा
  </a> */}
   <iframe
          src={SSP}
          title="Sainikshala PDF"
          width="100%"
          height="500px"
          style={{ border: "none", maxWidth: "800px" }}
        />
  
        <a
          href={SSP}
          download="Sainikshala.pdf"
          className="btn btn-success mt-3"
        >
          Download PDF
        </a>
</div>
</div>
</div>
        <div class="row" data-aos="zoom-in">
        <Tab.Container defaultActiveKey="index1">
  <Nav variant="tabs">
    <Nav.Item>
      <Nav.Link eventKey="index1">
      वैयक्तिक निकाल
      </Nav.Link>
    </Nav.Item>
  <Nav.Item>
      <Nav.Link eventKey="index2">
      केंद्रनिहाय गुणवत्ता यादी
      </Nav.Link>
    </Nav.Item>
      <Nav.Item>
      <Nav.Link eventKey="index3">
     सर्वसाधारण गुणवत्ता यादी
      </Nav.Link>
    </Nav.Item>
  </Nav>
  <div>
  <Tab.Content>
    <Tab.Pane eventKey="index1">
       
       <PersonelResult/>
   
    </Tab.Pane>
    <Tab.Pane eventKey="index2">
    <ShatabdiCenterwiseMeritList/>
    </Tab.Pane>
     <Tab.Pane eventKey="index3">
    <ShatabdiGeneralMeritList/>
    </Tab.Pane>
  </Tab.Content>
  </div>

</Tab.Container>
        </div>

      </div>
    </section>
    {/* <section id="services" class="services">
      <div class="container" data-aos="fade-up">
      <div class="alert alert-danger" role="alert">
           ज्या विद्यार्थ्यांच्या गुणांची फेरपडताळणी करावयाची असेल त्यांना दि. 5 एप्रिल 2026 अखेर प्रत्येक पेपरसाठी रु.50/- इतके शुल्क भरुन फेरपडताळणी करता येईल.  रक्कम संस्थेकडे जमा करणेसाठी सोबत दिलेल्या संस्थेच्या बँक अकौंटसाठीचा QR कोड स्कॅन करुन गुगल पे, फोन पे ने रक्कम भरता येईल रक्कम भरल्या नंतर त्याचा स्क्रीन शाॅट विद्यार्थ्याच्या नावासह 9822657772 या क्रमांकावर वॉटस् अप मेसेज करावा अथवा संस्थेच्या कार्यालयात समक्ष येऊन रक्कम भरता येईल.  विद्यार्थ्याच्या नावामध्ये दुरुस्ती असल्यास वरील मोबाईल नंबरवर वाॅटस अप मेसेजने कळवावे म्हणजे प्रमाणपत्रावर ती दुरुस्ती करता येईल.

</div>
<div class="alert alert-primary" role="alert">
उदाहरणार्थ  मराठी व गणित (पेपर 1), इंग्रजी व बुद्धिमत्ता (पेपर 2), म्हणजेच दोन्ही पेपर ची फेरपडताळणी करायची असेल तर प्रत्येकी 50 या हिशोबानी 100 रुपये भरावे लागतील.
</div>
  <div class="alert alert-danger" role="alert">
    कोणाच्याही  वैयक्तिक गुगल पे, फोन पे, स्कॅनर ला रक्कम पाठवू नये फक्त संस्थेच्या बँक ऑफ महाराष्ट्रच्याच स्कॅनरला पैसै पाठवावे. तसेच व्हॉटस अप ला मेसेज करताना 
विद्यार्थाचे पूर्ण नांव, इयत्ता, परीक्षेचा बैठक क्रमांक, विद्यार्थी शिकत असलेली शाळा, परीक्षा दिलेले सेंटरचे नांव, 
पेपर 1 का पेपर 2 कोणत्या पेपर ची तपासणी करायची आहे याची पूर्ण माहिती द्यावी भरलेल्या रकमेचा स्क्रीन शॉट Transaction Number / UPI Id सह सगळी माहिती पूर्णपणे देणे आवश्यक आहे.
</div>
 <div class="row">
            <div className="col-12 d-flex justify-content-center" data-aos="zoom-in" data-aos-delay="100">
            <div className="advertisement-box text-center">
              <img 
                src={qrcode} 
                alt="Sainikshala Advertisement" 
                className="img-fluid"
                style={{ maxWidth: '300px', width: '100%', height: 'auto' }}
              />
            </div>
          </div>
      
        </div>
       
      

      </div>
    </section> */}

</main>
            </>
        )
    }
  return (
  <WebTemplate>
    {ShatabdiResultScreen()}
  </WebTemplate>
  )
}

export default ShatabdiResult